module.exports = __webpack_public_path__ + "img/chevron.2f673701.svg";